<template>
  <div id="app">
    <!-- <router-view name="blank"></router-view> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" name="blank"></router-view>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view name="blank"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
  }
</script>

<style lang="scss">
  #app {
    background-color: #222d32;
  }
  .suo{
  text-align: center;
  border: 1px solid #e9e9eb;
  border-radius: 30px;
  font-size: 12px;
  display: inline-block;
  padding: 0px 10px;
}
.el-table .el-table__fixed-header-wrapper th, .el-table .el-table__header-wrapper th{
    font-size: 14px !important;
}
.el-tag{
    border-radius: 40px !important;
    font-size: 12px !important;
}
.el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #DCDFE6;
    border-radius: 8px 0 0 8px !important;
    box-shadow: none !important;
}
.el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 8px 8px 0 !important;
}
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
    -moz-appearance: textfield;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}
</style>